import Button from '../../../components/Button'
import { PageHeader } from '../../../components/PagesUtilities'
import Initial from '../../../components/Initial'
import useInitial from '../useInitial'
import { storagePage } from '../storage'
import useSubmitProduct from '../useSubmitProduct'
import { useParams } from 'react-router'
import ProductInfo from './ProductInfo'

function Buttons({ cancel }: { cancel: () => void }) {
    const submitProduct = useSubmitProduct()

    return (
        <>
            {storagePage.mode === 'creation' && (
                <Button color="ghost" onClick={() => cancel()}>
                    Cancelar
                </Button>
            )}
            {storagePage.mode === 'edition' && (
                <Button color="accent" onClick={() => cancel()}>
                    Cancelar
                </Button>
            )}
            {storagePage.mode === 'creation' && (
                <Button className="ml-2" onClick={() => submitProduct()}>
                    Confirmar
                </Button>
            )}
        </>
    )
}

export default function Product() {
    const { product_id } = useParams<{ product_id?: string }>()
    const { pageState, cancel } = useInitial(product_id)

    return (
        <Initial pageState={pageState}>
            <ProductInfo />
            <PageHeader subtitle="(*) Complete todos los campos para el producto">
                <Buttons cancel={cancel} />
            </PageHeader>
        </Initial>
    )
}
